export function PdfIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg
      width="32"
      height="41"
      viewBox="0 0 32 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect x="0.5" y="0.5" width="31" height="40" rx="3.5" fill="#F9FAFB" />
      <rect x="0.5" y="0.5" width="31" height="40" rx="3.5" stroke="#E5E7EB" />
      <rect x="5" y="6" width="22" height="2" fill="#D1D5DB" />
      <rect x="5" y="10" width="22" height="2" fill="#D1D5DB" />
      <rect x="5" y="14" width="22" height="2" fill="#D1D5DB" />
      <rect x="5" y="18" width="22" height="2" fill="#D1D5DB" />
      <rect x="5" y="22" width="22" height="2" fill="#D1D5DB" />
      <rect x="5.5" y="26" width="21" height="10" rx="2" fill="#B91C1C" />
      <path
        d="M8.60547 34V28.3633H10.9297C12.1172 28.3633 12.9102 29.1289 12.9102 30.2891V30.2969C12.9102 31.457 12.1172 32.2227 10.9297 32.2227H9.78516V34H8.60547ZM10.6406 29.2969H9.78516V31.3008H10.6406C11.3164 31.3008 11.7148 30.9414 11.7148 30.3008V30.293C11.7148 29.6523 11.3164 29.2969 10.6406 29.2969ZM13.9961 34V28.3633H16.2148C17.8906 28.3633 18.8594 29.375 18.8594 31.1406V31.1484C18.8594 32.9688 17.9023 34 16.2148 34H13.9961ZM15.1758 33.0273H16.0273C17.0703 33.0273 17.6562 32.3711 17.6562 31.168V31.1602C17.6562 30 17.0508 29.3359 16.0273 29.3359H15.1758V33.0273ZM19.9805 34V28.3633H23.6719V29.3359H21.1602V30.8477H23.4531V31.7812H21.1602V34H19.9805Z"
        fill="#FEF2F2"
      />
    </svg>
  )
}
